module.exports = __webpack_public_path__ + "img/aParty_121223_D.2b162b8e.jpg";